import moment from "moment-timezone";

export function formatDevices(devices: any[] | any) {
    if (Array.isArray(devices)) {
        return devices.map(e => {
            if (e.usedAt && e.usedAt.timestamp) {
                return {...e, usedAt: moment.utc(e.usedAt.timestamp * 1000).local().format('YYYY-MM-DD')};
            } else if (e.updatedAt && e.updatedAt.timestamp) {
                return {...e, usedAt: moment.utc(e.updatedAt.timestamp * 1000).local().format('YYYY-MM-DD')};
            } else if (e.createdAt && e.createdAt.timestamp) {
                return {...e, usedAt: moment.utc(e.createdAt.timestamp * 1000).local().format('YYYY-MM-DD')};
            }
            return {...e, usedAt: null};
        })
    }
    return devices;
}

export function sortByDates(date1: string, date2: string) {
    // @ts-ignore
    return new Date(date1) - new Date(date2);
}

type Criteria = {
    field: string;
    direction: number; //1 ORDER BY DESC and 0 ORDER BY ASC
}

export const sortBy = (devices: any[], arrCriteria: Criteria[]) => {
    arrCriteria.forEach(c => {
        devices.sort((f, s) => {
            let a = f[c.field];
            let b = s[c.field];
            // Special case for station
            if (c.field === 'station') {
                a = f.station?.code;
                b = s.station?.code;
            }
            // Handle null / undefined
            if (a == null && b == null) return 0;
            if (a == null) return c.direction === 0 ? 1 : -1;
            if (b == null) return c.direction === 0 ? -1 : 1;
            // Normal comparison
            const result = a.toString().localeCompare(b.toString(), undefined, { numeric: true });
            return c.direction === 0 ? result : -result;
        });
    });

    return devices;
};